"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _clsx = _interopRequireDefault(require("clsx"));
var _commonLibs = require("@mmc/common-libs");
var _commonCta = _interopRequireDefault(require("./common-cta.props/common-cta.defaultProps"));
var _commonCta2 = _interopRequireDefault(require("./common-cta.props/common-cta.propTypes"));
var _commonCta3 = _interopRequireDefault(require("./common-cta.css"));
var _div;
/* eslint-disable react/button-has-type */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var CommonCta = function CommonCta(props) {
  (0, _react.useEffect)(function () {
    var _props$data = props.data,
      selectActionType = _props$data.selectActionType,
      label = _props$data.label;
    var isCookieSettings = selectActionType === 'cookiesSettings';
    var cookieSettingsBtn = document.getElementById('od-stk-one');
    var observer = {};
    if (isCookieSettings) {
      // storing the label to retrieve it back once one-trust is loaded
      localStorage.setItem('btnLabel', label);
    }
    var handler = function handler(mutationList) {
      var btnLabel = localStorage.getItem('btnLabel');

      // once one-trust is loaded, change the button label to that from backend
      if (mutationList.length && cookieSettingsBtn.innerHTML !== btnLabel) {
        cookieSettingsBtn.innerHTML = btnLabel;
      }
    };
    if (isCookieSettings) {
      observer = new MutationObserver(handler);
      observer.observe(cookieSettingsBtn, {
        childList: true
      });
    }
    return function () {
      if (isCookieSettings) {
        observer.disconnect();
      }
      localStorage.removeItem('btnLabel');
    };
  }, []);
  var checkData = function checkData(data) {
    var url = data.url,
      label = data.label,
      priority = data.priority,
      theme = data.theme,
      openNewTab = data.openNewTab,
      icon = data.icon,
      customImage = data.customImage,
      ctaTheme = data.ctaTheme,
      ariaLabel = data.ariaLabel,
      ctaProps = data.ctaProps,
      roleTab = data.roleTab;
    return {
      url: url || data.URL || '',
      label: label || '',
      priority: priority || '',
      theme: theme || '',
      openNewTab: openNewTab || '',
      icon: icon || '',
      customImage: customImage || '',
      ctaTheme: ctaTheme || '',
      ariaLabel: ariaLabel || '',
      ctaProps: ctaProps || {},
      roleTab: roleTab
    };
  };
  var isLink = function isLink(url) {
    return !(url === null || url === undefined || url === '');
  };
  var isCustomImage = function isCustomImage(customImage) {
    return customImage.image !== undefined;
  };
  var checkForPrefixedLink = function checkForPrefixedLink(url, label, icon) {
    if (icon === 'Phone' && /\d/.test(label)) {
      return "tel:" + label.replace(/[A-Za-z]+[^\d]/, '');
    }
    // eslint-disable-next-line
    if (icon === 'Email' && /\@/.test(label)) {
      return "mailto:" + label;
    }
    return url;
  };
  var checkForClickShopURL = function checkForClickShopURL(url) {
    //check if the string url contains clickshop.mitsubishicars.com
    console.log("testing URL noopener");
    if (url.indexOf('clickshop.mitsubishicars.com') !== -1) {
      return "";
    } else {
      return "noopener noreferrer";
    }
  };
  var addPropsAsCustomClasses = function addPropsAsCustomClasses(options) {
    var block = props.block;
    var addedClasses = options.addedClasses,
      htmlElementType = options.htmlElementType,
      priority = options.priority,
      theme = options.theme,
      customImage = options.customImage,
      icon = options.icon,
      ctaTheme = options.ctaTheme,
      iconRight = options.iconRight;
    var _classes;
    if (htmlElementType === 'anchor') {
      _classes = [theme[priority], priority.toLowerCase().includes('icon') && !isCustomImage(customImage) ? theme["mmcIcon" + icon] : null];
    }
    if (htmlElementType === 'span') {
      _classes = [theme[ctaTheme]];
      if (iconRight) {
        _classes.push(_commonCta3["default"].iconRightContainer);
      }
    }
    // Add classes props
    if (addedClasses && Array.isArray(addedClasses)) {
      var _classes2;
      (_classes2 = _classes).push.apply(_classes2, addedClasses);
    } else if (addedClasses && typeof addedClasses === 'string') {
      _classes.push(addedClasses);
    }
    if (block) {
      _classes.push(_commonCta3["default"].block);
    }

    // Remove falsy
    _classes = _classes.filter(function (className) {
      return className;
    });
    return _classes;
  };
  var data = props.data,
    disabled = props.disabled,
    testID = props['data-testid'],
    section = props['data-section'],
    iconRight = props.iconRight;
  var selectActionType = data.selectActionType;
  var isCookieSettings = selectActionType === 'cookiesSettings';
  if (data) {
    var _checkData = checkData(data),
      url = _checkData.url;
    var _checkData2 = checkData(data),
      label = _checkData2.label,
      priority = _checkData2.priority,
      openNewTab = _checkData2.openNewTab,
      icon = _checkData2.icon,
      customImage = _checkData2.customImage,
      ctaTheme = _checkData2.ctaTheme,
      ctaProps = _checkData2.ctaProps,
      roleTab = _checkData2.roleTab;
    var clickEvent = props.clickEvent,
      keyDownEvent = props.keyDownEvent,
      keyUpEvent = props.keyUpEvent,
      mouseDownEvent = props.mouseDownEvent;
    // eslint-disable-next-line react/destructuring-assignment
    var theme = props.theme || {};
    var customAnchorClasses = addPropsAsCustomClasses({
      // eslint-disable-next-line react/destructuring-assignment
      addedClasses: props.classes,
      htmlElementType: 'anchor',
      priority: priority,
      theme: theme,
      customImage: customImage,
      icon: icon,
      ctaTheme: ctaTheme,
      iconRight: iconRight
    });
    var customSpanClasses = addPropsAsCustomClasses({
      // eslint-disable-next-line react/destructuring-assignment
      addedClasses: props.spanClasses,
      htmlElementType: 'span',
      priority: undefined,
      theme: theme,
      customImage: undefined,
      icon: undefined,
      ctaTheme: ctaTheme,
      iconRight: iconRight
    });
    if (roleTab) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: customSpanClasses.join(' ')
      }, /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
        role: "button",
        id: isCookieSettings ? 'od-stk-one' : testID,
        "data-testid": testID,
        "data-section": section,
        disabled: disabled,
        className: isCookieSettings ? (0, _clsx["default"])(_commonCta3["default"].overrideOT, 'ot-sdk-show-settings') : customAnchorClasses.join(' '),
        onClick: clickEvent,
        onKeyDown: keyDownEvent,
        onMouseDown: mouseDownEvent,
        onKeyUp: keyUpEvent
      }, ctaProps), isCustomImage(customImage) && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        src: customImage.image,
        alt: customImage.altText
      }), label));
    }
    if (isLink(url) && url.indexOf('clickshop.mitsubishi-motors.ca') !== -1) {
      var formattedUrl = (0, _commonLibs.setParamsForClickshopUrl)(url);
      url = formattedUrl.href;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLink(url) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isCustomImage(customImage) && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: handleNestedProp(customImage, 'customImage.image'),
      alt: handleNestedProp(customImage, 'customImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: customSpanClasses.join(' ')
    }, openNewTab ? /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
      "data-testid": testID,
      "data-section": section,
      href: checkForPrefixedLink(url, label, icon),
      className: customAnchorClasses.join(' '),
      target: "_blank",
      rel: checkForClickShopURL(url),
      onMouseDown: mouseDownEvent,
      onClick: clickEvent
    }, ctaProps), label) : /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
      "data-testid": testID,
      "data-section": section,
      href: checkForPrefixedLink(url, label, icon),
      className: customAnchorClasses.join(' '),
      onMouseDown: mouseDownEvent,
      onClick: clickEvent
    }, ctaProps), label))) : /*#__PURE__*/_react["default"].createElement("span", {
      className: customSpanClasses.join(' ')
    }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
      id: isCookieSettings ? 'od-stk-one' : testID,
      "data-testid": testID,
      "data-section": section,
      disabled: disabled,
      className: isCookieSettings ? (0, _clsx["default"])(_commonCta3["default"].overrideOT, 'ot-sdk-show-settings') : customAnchorClasses.join(' '),
      onClick: clickEvent,
      onKeyDown: keyDownEvent,
      onMouseDown: mouseDownEvent,
      onKeyUp: keyUpEvent
    }, ctaProps), isCustomImage(customImage) && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: customImage.image,
      alt: customImage.altText
    }), label)));
  }
  return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
};
CommonCta.resourceType = function () {
  return 'Common_CTA_1_0_0';
};
CommonCta.displayName = 'CommonCta';
CommonCta.defaultProps = {
  iconRight: false,
  data: _commonCta["default"]
};
var _default = CommonCta;
exports["default"] = _default;